import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Snackbar, Alert } from "@mui/material";
import { Grid } from "@mui/system";
import { useState } from "react";
import Wait from "./Wait";
import Mensaje from "./Mensaje"
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/AuthProvider";
import miAxios from "../api/axios";
import Confirmacion from "./Conformacion";


export default function CambioClave(props) {
    const [claveActual, setClaveActual] = useState("")
    const [clave, setClave] = useState("")
    const [repetir, setRepetir] = useState("")
    const [procesando, setProcesando] = useState("")
    const [openMensaje, setOpenMensaje] = useState("")
    const [mensaje, setMensaje] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState(false)

    const user = useAuth()
    const axios = miAxios(user.handleLogout)
    const navigate = useNavigate()

    const handleConfirmar = ()=>{
        if (puedeCambiar()){
            setOpenConfirmacion(true)
        }
    }

    const handleCambiar = ()=>{
        if (puedeCambiar()){
            cambiar()
        }
    }

    const puedeCambiar = ()=>{
        if (!claveActual){
            setMensaje("Debe introducir la clave actual");
            return false;
        }
        if (clave.length<8){
            setMensaje("Debe introducir una nueva clave de mínimo 8 caracteres")
            return false;
        }
        if (clave!=repetir){
            setMensaje("Claves no coinciden")
            return false;
        }
        return true;
    }

    const cambiar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)

        try {
            const response = await axios.post("usuarios/proveedor-usuario-cambiar-clave", {
                clave_anterior: claveActual,
                clave: clave
            })
            const data = response.data;
            if (data.respuesta == "S") {
                setOpenMensaje("Su clave ha sido cambiada exitosamente!")
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleCloseMensaje = () => {
        setMensaje("")
    }

    return <Dialog open={props.open} fullWidth>
        {
            procesando && (
                <Wait procesando={procesando} />
            )
        }
        {
            openMensaje && (
                <Mensaje
                    open={openMensaje}
                    texto={openMensaje}
                    cerrar={() => {props.cerrar() }}
                />
            )
        }
        {
            openConfirmacion && (
                <Confirmacion
                    open={openConfirmacion}
                    texto="Su clave será cambiada!"
                    cancelar={()=>{setOpenConfirmacion(false)}}
                    exito={handleCambiar}
                />
            )
        }
        <Snackbar
            open={mensaje.length == 0 ? false : true}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseMensaje}
        >
            <Alert severity="error" onClose={handleCloseMensaje} variant="filled">{mensaje}</Alert>
        </Snackbar>
        <DialogTitle color="coopinfa">Cambio de Clave</DialogTitle>
        <DialogContent>
            <Grid container spacing={2} sx={{ paddingTop: "20px" }}>
                <Grid size={12}>
                    <TextField
                        value={claveActual}
                        fullWidth
                        label="Clave Actual"
                        type="password"
                        onChange={(event) => { setClaveActual(event.target.value) }}
                        color="coopinfa"
                        slotProps={{ inputLabel: { shrink: true } }}
                    />
                </Grid>

                <Grid size={6}>
                    <TextField
                        value={clave}
                        fullWidth
                        label="Clave"
                        type="password"
                        onChange={(event) => { setClave(event.target.value) }}
                        color="coopinfa"
                        slotProps={{ inputLabel: { shrink: true } }}
                    />
                </Grid>
                <Grid size={6}>
                    <TextField
                        value={repetir}
                        fullWidth
                        label="Confirme"
                        type="password"
                        onChange={(event) => { setRepetir(event.target.value) }}
                        color="coopinfa"
                        slotProps={{ inputLabel: { shrink: true } }}
                    />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" color="coopinfa" onClick={()=>{props.cerrar()}}>Cancelar</Button>
            <Button variant="contained" color="coopinfa" onClick={handleConfirmar}>Cambiar</Button>
        </DialogActions>
    </Dialog>
}